import { Injectable, Inject } from '@angular/core';
import { Subject, Observable } from 'rxjs/';

@Injectable()
export class HyattEvent {

    public jgrnSavedSource = new Subject<any>();
    public jgrnSaved$ = this.jgrnSavedSource.asObservable();
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/events.services.ts